<template>
  <div class="loggedOutWrapper">
    <nuxt-link to="/influencer/signup/" class="navText">
      <b>{{ $t("layout.navigation09") }}</b>
    </nuxt-link>
    <action_button visual="hollowmain" class="thick" @click="openSignup">
      <div class="btnText">
        {{ $t("layout.navigation06") }}
      </div>
    </action_button>
    <div class="navText" @click="openLogin">
      {{ $t("layout.navigation07") }}
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex"

import action_button from "~/components/shared/actionButton"

export default {
  components: {
    action_button,
  },
  methods: {
    openLogin: function () {
      this.login_set_display(true)
    },
    openSignup: function () {
      this.band_signup_set_display(true)
    },
    ...mapActions({
      login_set_display: "login/SET_DISPLAY",
      band_signup_set_display: "band_signup/SET_DISPLAY",
    }),
  },
}
</script>
<style scoped>
.loggedOutWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

div.loggedOutWrapper > * {
  margin-right: 32px;
  cursor: pointer;
}

.loggedOutWrapper > *:last-child {
  margin-right: 0px;
}

.navText {
  font-size: var(--font-size-big);
  cursor: pointer;
}

b {
  font-weight: 600;
}

div.thick {
  border-width: 2px;
}
</style>
